const ACCESS_TOKEN_KEY = 'access_token';
const USER_KEY = 'user';

function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

async function login(username, password) {
  const url = process.env.VUE_APP_GQL_API_URL;
  const body = {
    query: `mutation login($username: String!, $password: String!){
      login(username: $username, password: $password) {
        accessToken
      }
    }`,
    variables: {
      username, password
    }
  }
  const response = await fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(body)
  });
  const responseBody = await response.json();
  const { data, errors } = responseBody;
  if (errors) {
    throw new Error(errors[0].message)
  }
  const { accessToken } = data.login
  const parsedJWT = parseJwt(accessToken)
  // save accessToken and user to localStorage
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(USER_KEY, JSON.stringify(parsedJWT));
}

async function sendResetCode(username) {
  const url = process.env.VUE_APP_GQL_API_URL;
  const body = {
    query: `mutation sendResetCode($username: String!){
      sendResetCode(username: $username){
        result
      }
    }`,
    variables: {
      username
    }
  }
  const response = await fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(body)
  });
  const responseBody = await response.json();
  const { data, errors } = responseBody;
  if (errors) {
    throw new Error(errors[0].message)
  }
  console.log(data);
}

async function resetPassword(username, resetCode, newPassword) {
  const url = process.env.VUE_APP_GQL_API_URL;
  const body = {
    query: `mutation resetPassword($username: String!, $resetCode: String!, $newPassword: String!){
      resetPassword(username: $username, resetCode: $resetCode, newPassword: $newPassword){
        result
      }
    }`,
    variables: {
      username, resetCode, newPassword
    }
  }
  const response = await fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(body)
  });
  const responseBody = await response.json();
  const { data, errors } = responseBody;
  if (errors) {
    throw new Error(errors[0].message)
  }
  return data
}

function logout() {
  resetStorage();
}

function currentAuthenticatedUser() {
  const u = localStorage.getItem(USER_KEY);
  if (u === null) {
    return null
  }
  const parsedUser = JSON.parse(u);
  return parsedUser;
}

function resetStorage() {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

function isAuthenticated() {
  const u = currentAuthenticatedUser();

  if (!u) {
    return false;
  }

  // compare expiration vs. current time
  const { exp } = u;
  const now = parseInt(Date.now() / 1000)

  if (exp <= now) {
    resetStorage()
    return false;
  }

  return true
}

function accessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export {
  login,
  logout,
  currentAuthenticatedUser,
  isAuthenticated,
  accessToken,
  sendResetCode,
  resetPassword,
  parseJwt
}